// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2bexq","rootSuccess":"CompleteLink_rootSuccess__3HXte","rootFailure":"CompleteLink_rootFailure__1INXp","isDisabled":"CompleteLink_isDisabled__1Ci8b"};